import React, { useEffect } from 'react';
import { CheckCircle2, Phone } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
export function WhyChooseUs() {
  const {
    t
  } = useLanguage();
  const controls = useAnimation();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  useEffect(() => {
    if (inView) {
      controls.start('visible');
    }
  }, [controls, inView]);
  return <section id="why-us" className="py-24 bg-gray-50 overflow-hidden" data-id="element-237">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-238">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-239">
          {/* Image Side */}
          <motion.div ref={ref} initial={{
          opacity: 0,
          x: -50
        }} animate={controls} variants={{
          visible: {
            opacity: 1,
            x: 0,
            transition: {
              duration: 0.6,
              ease: 'easeOut'
            }
          }
        }} className="w-full lg:w-1/2 relative" data-id="element-240">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-241">
              <img src="https://cdn.magicpatterns.com/uploads/5CVKY1mwHPpHn21ess4yZ9/hf_20260413_140141_4b11c648-257c-4e89-84aa-db21cfb45c59.png" alt="C&L Painting crew performing professional interior painting" className="w-full h-[500px] object-cover" data-id="element-242" />
              <div className="absolute inset-0 bg-brand-blue/10" data-id="element-243"></div>
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-brand-red/10 rounded-full -z-10 blur-2xl" data-id="element-244"></div>
            <div className="absolute -top-6 -left-6 w-48 h-48 bg-brand-blue/10 rounded-full -z-10 blur-2xl" data-id="element-245"></div>
          </motion.div>

          {/* Content Side */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} animate={controls} variants={{
          visible: {
            opacity: 1,
            x: 0,
            transition: {
              duration: 0.6,
              ease: 'easeOut',
              delay: 0.2
            }
          }
        }} className="w-full lg:w-1/2" data-id="element-246">
            <h2 className="text-3xl md:text-4xl font-heading font-extrabold text-brand-black mb-8" data-id="element-247">
              {t.whyUs.title}
            </h2>

            <div className="space-y-6 mb-10" data-id="element-248">
              {t.whyUs.points.map((point, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 10
            }} animate={controls} variants={{
              visible: {
                opacity: 1,
                y: 0,
                transition: {
                  duration: 0.4,
                  delay: 0.4 + index * 0.1
                }
              }
            }} className="flex items-center gap-4" data-id="element-249">
                  <div className="flex-shrink-0" data-id="element-250">
                    <CheckCircle2 className="w-6 h-6 text-brand-red" data-id="element-251" />
                  </div>
                  <p className="text-xl font-medium text-gray-800" data-id="element-252">{point}</p>
                </motion.div>)}
            </div>

            <a href="tel:8324397965" className="inline-flex items-center justify-center gap-2 bg-brand-blue text-white px-8 py-4 rounded-md font-bold text-lg hover:bg-blue-900 transition-all shadow-lg hover:-translate-y-0.5 min-h-[56px]" data-id="element-253">
              <Phone className="w-5 h-5" data-id="element-254" />
              {t.whyUs.cta}: (832) 439-7965
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}